import { observer } from 'mobx-react';
import React from 'react';
import { Carousel, CarouselItem, EqualHeightProvider, Text, TGridAlignment, TGridColumnWidth } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import OrderForm from './form/OrderForm';
import { GridProps, Package, PackageOptionGroup } from './MobileBusinessInterfaces';
import PackageCard from './selection/PackageCard';

export interface MobileBusinessPackageSelectionProps {
  formName: string;
  packageFieldId: number;
  totalPriceFieldId: number;
  packages: Package[];
  packageOptionGroups: PackageOptionGroup[];
  coverImageSrcSet?: string;
  gridProps?: GridProps;
}

const defaultGridProps = {
  grid: {
    align: ['center-xs', 'start-sm'] as TGridAlignment[],
  },
  gridColumn: {
    width: ['xs-8', 'sm-4', 'lg-3'] as TGridColumnWidth[],
  },
} as GridProps;

const MobileBusinessPackageSelection = (props: MobileBusinessPackageSelectionProps): JSX.Element => {
  const { gridProps, packageOptionGroups, packageFieldId, totalPriceFieldId, formName, packages } = props;
  const { translate } = React.useContext(TranslationsContext);

  const getCarouselItems = () => {
    const cards = packages.map((mobilePackage, index) => <PackageCard index={index} mobilePackage={mobilePackage} />);
    return cards.map((card, index) => <CarouselItem key={`mobile-package-carousel-item-${index}`}>{card}</CarouselItem>);
  };

  return (
    <Text>
      <EqualHeightProvider groups={['roaming', 'users', 'price', '5g']}>
        <Carousel
          nextArrowText={translate('carousel.next')}
          prevArrowText={translate('carousel.previous')}
          hasContainer={true}
          arrows={true}
          align="left"
          breakPoint={null}
          slidesToShow={1}
          responsive={[
            {
              breakPoint: 'md',
              props: { slidesToShow: 2 },
            },
            {
              breakPoint: 'lg',
              props: { slidesToShow: 3 },
            },
            {
              breakPoint: 'xl',
              props: { slidesToShow: 4 },
            },
          ]}
        >
          {getCarouselItems()}
        </Carousel>
      </EqualHeightProvider>
      <OrderForm
        formName={formName}
        packageFieldId={packageFieldId}
        totalPriceFieldId={totalPriceFieldId}
        packageOptionGroups={packageOptionGroups}
        gridProps={gridProps || defaultGridProps}
      />
    </Text>
  );
};

export default observer(MobileBusinessPackageSelection);
